import { ajaxSend } from '../../../api/api';
/**
 * Gets the activity logs for a conversation.
 *
 * @param csid The conversation id.
 */
export function getActivityLog(csid) {
    return ajaxSend({
        path: `/v1/conversations/${csid}/activity_log`,
    });
}
